/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from '@azure/msal-browser';

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */

export const msalConfig = {
    auth: {
        clientId: 'b469c7b8-75d6-4a95-873d-9a3eb36e1d94', // This is the ONLY mandatory field that you need to supply.
        authority: 'https://mylabentraextid.ciamlogin.com/mylabentraextid.onmicrosoft.com', // CIAM domain for authentication endpoints
        redirectUri: 'https://auth.itsdeepakslab.com', // Verified custom domain
        postLogoutRedirectUri: 'https://auth.itsdeepakslab.com', // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: true, // IMPORTANT: Must be true to handle MFA enrollment redirects properly
        knownAuthorities: ['mylabentraextid.ciamlogin.com', 'auth.itsdeepakslab.com'], // CIAM domain and verified custom domain
    },
    cache: {
        cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: [],
    // No ngcmfa claims on initial login - user signs in first, then sets up MFA via CA policy naturally
};

// Separate request for passkey operations that requires MFA
const claimsRequestValue = {
    "id_token": {
        "amr": {
            "essential": true,
            "values": ["ngcmfa"]
        }
    },
    access_token: {
        amr: {
            essential: true,
            values: ['ngcmfa']
        }
    }
};
const claims = JSON.stringify(claimsRequestValue);
export const passkeyOperationRequest = {
    scopes: [],
    // This request is used only for passkey operations (add/delete)
    // It enforces ngcmfa, requiring re-authentication with MFA every 15 minutes
    extraQueryParameters: {
        claims: claims,
    },
};


/**
 * Application configuration for backend services
 * These values are now directly configured instead of using environment variables
 */
export const appConfig = {
    proxyDomain: 'https://white-ground-0ce88720f.3.azurestaticapps.net/api/proxy',
    appId: 'b469c7b8-75d6-4a95-873d-9a3eb36e1d94',
    appSecret: 'wZF8Q~tW41BUCmX4kbKn7K4_FcVsFw0JhVrKXaL4',
    tenantId: '1693d295-ada3-48d9-9b49-5c9f447488cc',
    customDomain: 'auth.itsdeepakslab.com', // Verified custom domain in Entra External ID for passkey operations
};